module.exports = __webpack_public_path__ + "static/img/peoIcon.12e76c22.svg";